(function() {
  const waterReportForm = (props) => ({
    zipCode: '',
    waterProviders: [],
    selectedProvider: '',
    selectedProviderRetailUrl: '',
    isLoading: false,
    showProviderSelect: false,
    typingTimer: null,
    doneTypingInterval: 1000,
    firstName: '',
    phoneNumber: '',
    email: '',
    klaviyoListId: props.klaviyo_list_id,
    klaviyoFormSubmissionEventName: props.klaviyo_form_submission_event_name,
    thankYouPageUrl: props.thank_you_page_url,
    formType: props.form_type,
    klaviyo_water_report_bucket_name: props.klaviyo_water_report_bucket_name,

    init() {
      this.$watch('showPersonDetails', (newValue, oldValue) => {
        if (newValue !== oldValue) {
          this.firstName = this.$refs.firstName.value;
          this.phoneNumber = this.$refs.phoneNumber.value;
          this.email = this.$refs.email.value;
        }
      })
    },

    get showPersonDetails() {
      return !!this.selectedProvider;
    },
    
    async getAreas() {
      
      if (!this.zipCode.trim()) {
        this.showProviderSelect = false;
        this.waterProviders = [];
        return;
      }
      
      this.isLoading = true;
      
      try {
        // Fetch water providers from the API
        const response = await fetch(`https://ww2.tyentusa.com/waterreport.php?zip=${this.zipCode}`);
        const html = await response.text();
        
        // Parse the HTML to extract select options
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const select = doc.querySelector('#waterProviderSelect');
        
        // fixed this section to deduplicate water providers on some zip codes, fixed alpine crash -Daniel
        if (select) {
          // 1) sanitize + filter
          const providers = Array.from(select.options).map((option) => ({
              value: (option?.value ?? '').trim(),
              text: (option?.text ?? '').trim(),
            }))
            .filter((p) => p.value.length > 0);

          // 2) dedupe by value
          const seen = new Set();
          const uniqueProviders = [];

          for (const p of providers) {
            if (seen.has(p.value)) continue;
            seen.add(p.value);

            const r = p.value.replace('system.php?pws=', '');

            uniqueProviders.push({
              value: p.value,
              text: p.text,
              reportUrl: `https://www.tyentusa.com/pages/water-wizard?r=${r}`,
              retailUrl: `https://www.tyentusa.com/pages/free-drinking-water-report?r=${r}`,
            });
          }

          this.waterProviders = uniqueProviders;
          this.showProviderSelect = this.waterProviders.length > 0;

          // optional: quick debug to confirm uniqueness
          // console.log('providers count:', this.waterProviders.length);
        } else {
          this.waterProviders = [];
          this.showProviderSelect = false;
        }
        /*
        if (select) {
          this.waterProviders = Array.from(select.options).filter(option => !!option?.value).map(option => ({
            value: option.value,
            text: option.text,
            reportUrl: `https://www.tyentusa.com/pages/water-wizard?r=${option.value.replace('system.php?pws=', '')}`,
            retailUrl: `https://www.tyentusa.com/pages/free-drinking-water-report?r=${option.value.replace('system.php?pws=', '')}`
          }));
          
          this.showProviderSelect = true;
        } else {
          this.waterProviders = [];
          this.showProviderSelect = false;
        }
          */
      } catch (error) {
        console.error('Error fetching water providers:', error);
        this.waterProviders = [];
        this.showProviderSelect = false;
      } finally {
        this.isLoading = false;
      }
    },
    
    onZipInput() {
      // Clear existing timer
      clearTimeout(this.typingTimer);
      
      // Set new timer to fetch providers after typing stops
      this.typingTimer = setTimeout(() => {
        this.getAreas();
      }, this.doneTypingInterval);
    },
    
    onProviderChange() {
      if (this.selectedProvider) {
        const provider = this.waterProviders.find(p => p.value === this.selectedProvider);
        if (provider) {
          this.selectedProviderRetailUrl = provider.retailUrl;
        }
      }
    },

    async handleZipForm() {
      if (this.zipCode.trim()) {
        if (this.waterProviders.length > 0 && !this.selectedProvider) {
          console.log('Please select a water provider');
          return;
        }
        
        console.log('Submitting water report for ZIP:', this.zipCode);
        
        if (this.selectedProvider) {
          const provider = this.waterProviders.find(p => p.value === this.selectedProvider);
          await this.track();
          if (provider) {
            // Redirect to the report URL
            window.location.href = this.thankYouPageUrl;
          }
        } else {
          // No providers found, handle accordingly
          console.log('No water providers found for this ZIP code');
        }
      } else {
        console.log('Please enter a ZIP code');
      }
    },

    async handleEmailForm() {
      await this.track();
      window.location.href = this.thankYouPageUrl;
    },
    
    async submitForm() {

      if (this.formType === 'zip') {
        await this.handleZipForm();
      } else {
        await this.handleEmailForm();
      }
    
    },

    async track() {

      await this.klaviyoTrack();

      var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        "method": "POST",
        "headers": {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache"
        },
        "data": {
          "g": this.klaviyoListId, 
          "email": this.email,
          "$fields": "$source, $first_name, $phone, $zip, address_home_zip, water_report_retail_url, water_report_bucket_name",
          "$source": "Water Report Form",
          ...(this.formType === 'zip' ? {
            "$first_name": this.firstName,
            "$phone": this.phoneNumber,
            "$zip": this.zipCode,
            "address_home_zip" : this.zipCode,
            "water_report_retail_url": this.selectedProviderRetailUrl,
            "water_report_bucket_name": this.klaviyo_water_report_bucket_name
          } : {})
        }
      };

      await fetch(settings.url, {
        method: settings.method,
        headers: settings.headers,
        body: new URLSearchParams(settings.data)
      });
    },

    async klaviyoTrack() {
        const KLAVIYO_PUBLIC_API_KEY = "XLkecu";
    
        try {
            const properties = {
                "$email": this.email,
                ...(this.formType === 'zip' && {
                    "$first_name": this.firstName,
                    "first_name": this.firstName,
                    "$phone_number": this.phoneNumber,
                    "phone": this.phoneNumber,
                    "$zip": this.zipCode,
                    "address_home_zip": this.zipCode,
                    "water_report_retail_url": this.selectedProviderRetailUrl,
                    "water_report_bucket_name": this.klaviyo_water_report_bucket_name
                })
            };
    
            const identifyOptions = {
                method: 'POST',
                headers: {accept: 'text/html', 'content-type': 'application/x-www-form-urlencoded'},
                body: new URLSearchParams({
                    data: JSON.stringify({
                        "token": KLAVIYO_PUBLIC_API_KEY,
                        "properties": properties
                    })
                })
            };
    
            await fetch('https://a.klaviyo.com/api/identify', identifyOptions)
                .then(res => res.json())
                .then(res => console.log(res))
                .catch(err => console.error(err));
    
            const trackOptions = {
                method: 'POST',
                headers: {accept: 'text/html', 'content-type': 'application/x-www-form-urlencoded'},
                body: new URLSearchParams({
                    data: JSON.stringify({
                        "token": KLAVIYO_PUBLIC_API_KEY,
                        "event": this.klaviyoFormSubmissionEventName,
                        "customer_properties": {
                            "$email": this.email
                        },
                        "properties": {
                            "url": window.location.href,
                            "water_report_bucket_name": this.klaviyo_water_report_bucket_name
                        }
                    })
                })
            };
    
            await fetch('https://a.klaviyo.com/api/track', trackOptions)
                .then(res => res.json())
                .then(res => console.log(res))
                .catch(err => console.error(err));
                
            console.log("Klaviyo identify + track completed successfully");
        } catch (err) {
            console.error("Error sending Klaviyo events:", err);
        }
    }
  });
 
// Register the component with Alpine using the alpine:init event
document.addEventListener('alpine:init', () => {
  Alpine.data('waterReportForm', waterReportForm);
});
 
// Fallback if Alpine is already loaded
if (window.Alpine) {
  Alpine.data('waterReportForm', waterReportForm);
}
})();
